module.exports = __webpack_public_path__ + "static/media/logo-white.eec7c7f6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/logo-white.svg
// module id = 905
// module chunks = 0